import { zdarzenie } from '../lib/pomiar'
import { apiFetch } from './apiFetch'

const apiUrl = process.env.REACT_APP_API_URL || '/api/'

// Który kreator dał wynik, do lejka w panelu pomiaru (`pomiar/podsumowanie.py`).
const KREATOR = { 'dobor_falownika/': 'falownik', 'dobor_modulu/': 'modul', 'dobor_magazynu/': 'magazyn' }

/**
 * Atrybuty z danych badawczych dla modeli falowników (backup, serwis, aplikacja).
 *
 * Front NIE liczy tego u siebie: dane siedzą w tabelach `inverter_*_attribute`,
 * a złączenie z katalogiem wymaga wyliczenia serii, co robi backend.
 */
export const pobierzAtrybuty = async (modelIds) => {
  const ids = (modelIds || []).filter((x) => Number.isInteger(x))
  if (ids.length === 0) return { ok: true, data: {} }
  try {
    const res = await apiFetch(`${apiUrl}atrybuty_inwertera/?model_ids=${ids.join(',')}`)
    if (!res.ok) return { ok: false, error: 'Nie udało się wczytać danych o falownikach.' }
    return { ok: true, data: await res.json() }
  } catch {
    return { ok: false, error: 'Brak połączenia z serwerem.' }
  }
}

/**
 * Atrybuty z danych badawczych dla modeli magazynów energii.
 *
 * Osobny endpoint, a nie wspólny z falownikami: magazyny mają WYŁĄCZNIE poziom
 * marki (seria baterii to zwykle jeden model w kilku pojemnościach), więc
 * odpowiedź ma inny kształt — bez pola `seria` — i inny zestaw pól.
 */
export const pobierzAtrybutyMagazynu = async (modelIds) => {
  const ids = (modelIds || []).filter((x) => Number.isInteger(x))
  if (ids.length === 0) return { ok: true, data: {} }
  try {
    const res = await apiFetch(`${apiUrl}atrybuty_magazynu/?model_ids=${ids.join(',')}`)
    if (!res.ok) return { ok: false, error: 'Nie udało się wczytać danych o magazynach.' }
    return { ok: true, data: await res.json() }
  } catch {
    return { ok: false, error: 'Brak połączenia z serwerem.' }
  }
}

/** Trzy propozycje falownika z całego katalogu na podstawie odpowiedzi z kreatora. */
export const dobierzFalownik = async (kryteria) => wyslijDobor('dobor_falownika/', kryteria)

/** Trzy propozycje modułu PV na podstawie odpowiedzi z kreatora. */
export const dobierzModul = async (kryteria) => wyslijDobor('dobor_modulu/', kryteria)

/** Trzy propozycje magazynu energii, ze sprawdzeniem zgodności z falownikiem. */
export const dobierzMagazyn = async (kryteria) => wyslijDobor('dobor_magazynu/', kryteria)

/**
 * Podpowiedzi do pytania „jaki masz model" w kreatorze rozbudowy.
 * `kategoria` to 'panel' albo 'inwerter'.
 */
export const szukajModeli = async (kategoria, { q, moc, rodzaj, producent } = {}) => {
  const par = new URLSearchParams({ kategoria })
  if (q) par.set('q', q)
  if (moc) par.set('moc', moc)
  if (rodzaj) par.set('rodzaj', rodzaj)
  if (producent) par.set('producent', producent)
  const res = await apiFetch(`${apiUrl}szukaj_modeli/?${par}`)
  if (!res.ok) return { wyniki: [] }
  return res.json()
}

/** Wartości do list zawężających (moc, rodzaj, producent) — prosto z katalogu. */
export const opcjeModeli = async (kategoria) => {
  const res = await apiFetch(`${apiUrl}opcje_modeli/?kategoria=${kategoria}`)
  if (!res.ok) return { producenci: [], rodzaje: [], moce: [] }
  return res.json()
}

/** Wspólna wysyłka kryteriów — trzy kreatory różnią się tylko adresem. */
async function wyslijDobor(sciezka, kryteria) {
  try {
    const res = await apiFetch(`${apiUrl}${sciezka}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(kryteria),
    })
    if (!res.ok) return { ok: false, error: 'Nie udało się dobrać produktu.' }
    const data = await res.json()
    zdarzenie('kreator_wynik', KREATOR[sciezka])
    return { ok: true, data }
  } catch {
    return { ok: false, error: 'Brak połączenia z serwerem.' }
  }
}
